import React, { useEffect } from 'react';
import './HomeSkillProgressBar.css';
import Aos from 'aos';
import "aos/dist/aos.css";


const HomeSkillProgressBar = ({animationType,bgcolor,tech,progress,height}) => {
  const animtype = {
    0: 'fade-up',
    1: 'fade-down',
    2: 'fade-left',
    3: 'fade-right',
  }
     
    const Parentdiv = {
        height: height
      }
      
      const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: bgcolor,
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        overflow: 'hidden'
      }
      
      const progresstext = {
        padding: 5,
        paddingLeft: 10,
        color: '#0f0f0f',
        fontSize: '14px',
        borderRadius: 1,
        backgroundColor: '#8787873b',
        fontWeight: 900
      }

    return (
    <div data-aos={animtype[animationType]} className="parent-div" style={Parentdiv}>
      <div style={Childdiv}><span style={progresstext}>{tech.toUpperCase()} {`${progress}%`}</span>
      </div>
    </div>
    )

};

export default HomeSkillProgressBar;